import {RemoteCollectionStore, StoreBuilder} from '@softline/core';
import {EtikettendruckArtikelDetail} from '../data/etikettendruck-artikel-detail';

export const EtikettendruckArtikelDetailStore =
  new StoreBuilder(RemoteCollectionStore.create<EtikettendruckArtikelDetail>())
    .value
